export const FRONTEND = {
  SETTINGS: "/admin/settings",
  MY_EDGE: "/admin/my-edge",
  WELCOME: "/admin/welcome",
  TEMPLATES: "/admin/templates",
  MY_RFPS: "/admin/rfp",
  SAVED_SEARCHES: "/admin/my-edge/saved-searches",
  SHORTLISTS: "/admin/my-edge/saved-searches",
  LATEST_UPDATES: "/admin/edge-agency-update",
  COMMERCIAL_DEALS: {
    INDEX: "/admin/commercial-deals",
    CREATE: "/admin/commercial-deals/create",
    EDIT: "/admin/commercial-deals/:id",
  },
};
